import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { useField } from 'formik';
import FormGroup from './FormGroup';

function SelectField({
  name,
  label,
  options,
  searchable,
  onChangeValue,
  reset
}) {
  const [field, meta, helpers] = useField(name);

  // Resetovani vlastnich stylu a pouzijeme stylovani pres CSS
  const customStyles = {
    control: () => ({}),
    valueContainer: () => ({}),
    placeholder: () => ({}),
    indicatorSeparator: () => ({}),
    option: () => ({})
  };

  return (
    <FormGroup>
      {label && (
        <label className="input-label" htmlFor={field.name}>
          {label}
        </label>
      )}
      <Select
        id={field.name}
        name={name}
        isSearchable={searchable}
        styles={customStyles}
        className={`${meta.error ? 'react-select--has-error' : ''}`}
        classNamePrefix="react-select"
        options={options}
        placeholder="Vyberte..."
        // Propojení s Formikem
        value={
          !reset ? options.find((option) => option.value === field.value) : null
        }
        onChange={(option) => {
          helpers.setValue(option.value);
          if (onChangeValue !== undefined) {
            onChangeValue(name, option.value);
          }
        }}
      />
    </FormGroup>
  );
}

SelectField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  searchable: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.object).isRequired
};

SelectField.defaultProps = {
  label: null,
  searchable: false
};

export default SelectField;
